import axios from "axios";
import { useLocalSearchParams, useRouter } from "expo-router";
import React, { useState } from "react";
import {
  ActivityIndicator,
  KeyboardAvoidingView,
  Modal,
  Platform,
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View
} from "react-native";
import { TextInput } from "react-native-gesture-handler";
import Icon from "react-native-vector-icons/FontAwesome";
import { useDispatch, useSelector } from "react-redux";
// ⚠️ สำคัญ: ต้องรันคำสั่ง npx expo install expo-keep-awake ก่อนรันโปรเจกต์
import { activateKeepAwakeAsync, deactivateKeepAwakeAsync } from "expo-keep-awake";
import FooterComponent from "../component/footer";
import { postCancelOrder, postWeight } from "../redux/actions/scaleactions";
import { useLanguage } from "./LanguageProvider";

export default function Retrieve() {
  const [isShowscale, setisShowscale] = useState(false);
  const [weight, setWeight] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingresponse, setLoadingresponse] = useState(false);
  const [error, setError] = useState(null);
  const router = useRouter();
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);
  const [modalSuccessVisible, setModalSuccessVisible] = useState(false);
  const [modalSuccessVisible2, setModalSuccessVisible2] = useState(false);
  const [modalFailedVisible, setModalFailedVisible] = useState(false);
  const [modalFailedVisible2, setModalFailedVisible2] = useState(false);
  const [modalReelcustomerVisible, setModalReelcustomerVisible] =
    useState(false);
  const [checkwarning, setCheckwarning] = useState(false);
  const [messagefailed, setMessagefailed] = useState("");
  const { item: itemParam, item2: item2Data } = useLocalSearchParams();
  
  const [customer_reel, setCustomer_reel] = useState("");
  const [shift, setShift] = useState("A"); // ⚠️ เก็บค่ากะงาน ค่าเริ่มต้นคือ กะ A (กลางวัน)
  
  const { t } = useLanguage();

  const profile =
    useSelector((state: any) => state?.auth?.profile?.user?.[0]) || null;

  const scale = useSelector((state: any) => state?.scale?.scale) || null;

  const postwip =
    useSelector((state: any) => state?.scale?.postweightwip?.[0]) || null;

  const item =
    typeof itemParam === "string" ? JSON.parse(itemParam) : itemParam;

  const item2 =
    typeof item2Data === "string" ? JSON.parse(item2Data) : item2Data;

  const fetchWeight = async () => {
    setLoading(true);
    setError(null);
    try {
      let rawUrl = item2?.url_req || "";
      let pathOnly = rawUrl.replace(/^https?:\/\//i, "");
      let proxyUrl = `/proxy-scales/${pathOnly}`;

      if (Platform.OS !== "web") {
        const NGINX_HOST = "https://scalsweb.veninecopper.com"; 
        proxyUrl = `${NGINX_HOST}${proxyUrl}`;
      }

      console.log("Fetching weight via Nginx Proxy:", proxyUrl);

      const response = await axios.get(proxyUrl, { timeout: 10000 });
      const data = response.data;

      if (response.status === 200) {
        setWeight(data.menge);
        setisShowscale(true);
      } else {
        throw new Error(t("message_error") as any);
      }
    } catch (err) {
      console.error("Fetch Weight Error:", err);
      setError(t("message_error_pull_data") as any);
      setWeight(null);
    } finally {
      setLoading(false);
    }
  };

  const postWeightData = async () => {
    // ⚠️ ดักการกดปุ่มเบิ้ล
    if (loadingresponse) return; 

    setLoadingresponse(true);
    try {
      // ⚠️ เปิดโหมดป้องกันหน้าจอดับ (หน้าจอจะสว่างตลอดเวลาตอนส่งข้อมูล)
      await activateKeepAwakeAsync();

      const response = await dispatch(
        postWeight(scale, weight, profile, item, postwip, customer_reel, shift) as any
      );

      if (response.success === true) {
        setModalSuccessVisible(true);
      } else {
        setMessagefailed(response.message);
        setModalFailedVisible(true);
      }
    } catch (error) {
      console.error("เกิดข้อผิดพลาด:", error);
      setModalFailedVisible(true);
    } finally {
      setLoadingresponse(false);
      // ⚠️ ยกเลิกโหมดป้องกันหน้าจอดับ
      await deactivateKeepAwakeAsync();
    }
  };
// ⚠️ ฟังก์ชันสำหรับ Resume Check (เวอร์ชันปรับแต่งเงื่อนไขตาม Data จริง)
  const checkTransactionStatus = async () => {
    setModalFailedVisible(false);

    setTimeout(async () => {
      setLoadingresponse(true);
      try {
        let apiUrl = `/proxy-api/api/v1/printlabel/order/${item?.order_number}`; 

        if (Platform.OS !== "web") {
          const API_HOST = "https://scalsweb.veninecopper.com"; 
          apiUrl = `${API_HOST}${apiUrl}`;
        }

        console.log("🔍 Checking status via Proxy API:", apiUrl);
        const response = await axios.get(apiUrl, { timeout: 10000 });

        const printHistory = response.data?.data || [];
        const currentWeight = parseFloat(weight as any);
        
        // 🛠️ ใช้รหัสเครื่องชั่งจากหน้าจอ มาเป็นตัวช่วยยืนยันแทนรหัสพนักงาน
        const currentMachine = item2?.machine_code || ""; 

        // [...printHistory].reverse() = ค้นหาจากรายการล่าสุดย้อนขึ้นไป
        const isRecordFound = Array.isArray(printHistory) && [...printHistory].reverse().find((record: any) => {
          
          // 1. เช็คน้ำหนัก (เช่น "884.000" แปลงเป็น 884 มาเทียบกัน)
          const recordWeight = parseFloat(record?.totalWeight || 0);
          const isWeightMatch = recordWeight === currentWeight;

          // 2. เช็ครหัสเครื่องชั่ง ต้องตรงกับเครื่องที่เรายืนกดอยู่ (เช่น "11DW01")
          const isMachineMatch = currentMachine === "" || record?.machineNo === currentMachine;

          // 3. เช็คว่า SAP ออกเลข materialDoc มาเรียบร้อยแล้ว
          const hasMaterialDoc = !!record?.materialDoc && String(record?.materialDoc).trim() !== "";

          // 4. เช็คเวลา createdAt (ต้องเพิ่งเกิดภายใน 6 ชั่วโมง เผื่อเวลา Server กับ Tablet ไม่ตรงกัน)
          let isRecent = true;
          if (record?.createdAt) {
             const recordTime = new Date(record.createdAt.replace(' ', 'T')).getTime();
             const now = new Date().getTime();
             // หาความต่างของเวลาเป็นชั่วโมง
             const diffHours = Math.abs(now - recordTime) / (1000 * 60 * 60);
             isRecent = diffHours <= 6; 
          }

          // ⚠️ ต้องผ่านทั้ง 4 ด่าน ถึงจะการันตีได้ว่าเป็นข้อมูลที่เราเพิ่งส่งไปจริงๆ
          return isWeightMatch && isMachineMatch && hasMaterialDoc && isRecent;
        });

        if (isRecordFound) {
          // ✅ เจอตัวจริงเสียงจริง! เปิดหน้า Success ข้ามไปทำงานต่อได้เลย
          setModalSuccessVisible(true); 
        } else {
          // ❌ ยังไม่เจอ แปลว่า SAP น่าจะยังหมุนอยู่จริงๆ
          setMessagefailed("กำลังรอ SAP ประมวลผล (หรือยังไม่พบข้อมูล) กรุณาลองอีกครั้ง");
          setModalFailedVisible(true);
        }
      } catch (err: any) {
        console.error("❌ Check Status Error:", err);
        setMessagefailed("ไม่สามารถเชื่อมต่อเพื่อตรวจสอบสถานะได้");
        setModalFailedVisible(true);
      } finally {
        setLoadingresponse(false);
      }
    }, 400); // หน่วงเวลาให้แอนิเมชัน Modal ปิดสนิทก่อน 0.4 วินาที
  };

  const handleCancel = async () => {
    setLoadingresponse(true);
    try {
      const response = await dispatch(postCancelOrder(item, item2) as any);

      if (response.success === true) {
        setModalSuccessVisible2(true);
      } else {
        setMessagefailed(response.message);
        setModalFailedVisible2(true);
      }
    } catch (error) {
      console.error("เกิดข้อผิดพลาด:", error);
      setModalFailedVisible2(true);
    } finally {
      setLoadingresponse(false);
    }
  };

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        <KeyboardAvoidingView
          behavior={Platform.OS === "ios" ? "padding" : "height"}
          className="absolute mt-2 top-0 w-[90%] h-[85%] px-2 bg-white rounded-2xl border border-gray-200 shadow-xl"
          keyboardVerticalOffset={Platform.OS === "ios" ? 20 : 0}
        >
          <ScrollView
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: "space-between",
              padding: 20,
            }}
            showsVerticalScrollIndicator={false}
          >
            {/* Title */}
            <View className="w-full items-center justify-center border-b border-gray-300 pb-1">
              <Text className="text-2xl font-kanit py-2 text-gray-700">
                {t("pull_weight_data")}
              </Text>
            </View>

            {/* Content */}
            <View className="w-full flex-1 py-2">
              <View className="flex flex-row items-center justify-between pt-1">
                <View className="flex flex-wrap items-start">
                  <Text className="text-lg text-gray-600 font-kanit">
                    {item2?.machine_code
                      ? item2?.machine_code
                      : t("no_data")}
                    <Text className="text-sm text-red-500 font-kanit">
                      {" "}
                      {item?.order_name} {"(" + item?.material_code + ")"}
                    </Text>
                  </Text>
                  <Text className="text-sm text-sky-500 font-kanit">
                    <Text className="text-sm text-gray-500 font-kanit">
                      {t("position")} :{" "}
                    </Text>
                    {item?.position
                      ? item?.position
                      : t("no_data")}
                    <Text className="text-sm text-emerald-500 font-kanit">
                      {" || "}
                    </Text>
                    <Text className="text-sm text-gray-500 font-kanit">
                      {t("order_number")} :{" "}
                    </Text>
                    {item?.order_number ? item?.order_number : t("no_data")}
                    <Text className="text-sm text-emerald-500 font-kanit">
                      {" || "}
                    </Text>
                    <Text className="text-sm text-gray-500 font-kanit">
                      {t("type")} :{" "}
                    </Text>
                    {item?.type
                      ? item?.type === "wip"
                        ? t("wip")
                        : item?.type === "waste"
                        ? t("waste")
                        : item?.type === "good"
                        ? t("good")
                        : t("no_data")
                      : t("no_data")}
                  </Text>
                </View>

                {isShowscale && !loading && (
                  <TouchableOpacity
                    onPress={fetchWeight}
                    className="rounded-full bg-gray-100 px-4 py-2 flex-row items-center"
                  >
                    <Icon name="refresh" size={16} color="#1688fa" />
                    <Text className="text-lg text-blue-500 font-kanit pl-2">
                      {t("pull_data_again")}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>

              {loading ? (
                <>
                  <View className="w-full flex-1 items-center justify-center py-2">
                    <ActivityIndicator size="large" color="#58d68d" />
                    <Text className="text-lg text-gray-600 font-kanit pt-4">
                      {t("loading_pull_data")}
                    </Text>
                  </View>
                </>
              ) : error ? (
                <>
                  <View className="w-full flex-1 items-center justify-center py-2">
                    <Icon name="exclamation-circle" size={28} color="#ec7063" />
                    <Text className="text-xl text-red-500 font-kanit pt-4">
                      {error}
                    </Text>
                    <TouchableOpacity
                      onPress={fetchWeight}
                      className="rounded-full bg-gray-100 px-4 py-2 flex-row items-center mt-4"
                    >
                      <Icon name="refresh" size={16} color="#ec7063" />
                      <Text className="text-lg text-red-500 font-kanit pl-2">
                        {t("try_again")}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </>
              ) : isShowscale ? (
                <>
                  <View className="w-full flex-1 items-center justify-center py-2">
                    <View className="w-full flex-row items-center justify-center py-2">
                      <Text className="text-9xl font-kanit text-[#58d68d] pt-4">
                        {weight ? weight : "0"}
                      </Text>
                      <Text className="text-2xl font-kanit text-[#58d68d] pt-4">
                        KG.
                      </Text>
                    </View>
                  </View>

                  <View className="w-full flex-row items-center justify-center rounded-xl">
                    <View className="flex-1 items-start justify-center bg-gray-100 rounded-xl py-2 m-2">
                      <View className="flex-row items-center justify-center">
                        <Text className="text-2xl text-gray-700 font-kanit pl-4 ">
                          {t("weight_container")}
                        </Text>
                      </View>
                      <View className="w-full flex-1 flex-row items-center justify-center pb-2">
                        <Text className="text-7xl font-kanit text-[#1688fa]">
                          {item?.container_weight
                            ? item?.container_weight
                            : "0"}
                        </Text>
                        <Text className="text-xl font-kanit text-[#1688fa] ml-2">
                          KG.
                        </Text>
                      </View>
                    </View>

                    <View className="flex-1 items-start justify-center bg-gray-100 rounded-xl py-2 m-2">
                      <View className="flex-row items-center justify-center">
                        <Text className="text-2xl text-gray-700 font-kanit pl-4 ">
                          {t("weight_work")}
                        </Text>
                      </View>
                      <View className="w-full flex-1 flex-row items-center justify-center pb-2">
                        <Text className="text-7xl font-kanit text-[#1688fa]">
                          {(() => {
                            const result = item?.container_weight
                              ? parseFloat(weight as any) -
                                parseFloat(item?.container_weight)
                              : parseFloat(weight as any);

                            return Number.isInteger(result)
                              ? result
                              : result.toFixed(2);
                          })()}
                        </Text>
                        <Text className="text-xl font-kanit text-[#1688fa] ml-2">
                          KG.
                        </Text>
                      </View>
                    </View>
                  </View>

                  <View className="w-full flex-row items-center justify-center rounded-xl mt-1">
                    <View className="flex-1 items-start justify-center rounded-xl py-2 m-2">
                      <Text className="text-lg text-gray-500 font-kanit">
                        กะการทำงาน (Shift)
                      </Text>
                      <View className="flex-row mt-2 w-full shadow-sm">
                        <TouchableOpacity
                          onPress={() => setShift("A")}
                          className={`flex-1 py-3 rounded-l-xl border border-gray-300 items-center justify-center ${
                            shift === "A" ? "bg-[#1688fa] border-[#1688fa]" : "bg-gray-100"
                          }`}
                        >
                          <Text className={`font-kanit text-lg ${shift === "A" ? "text-white" : "text-gray-600"}`}>
                            กะกลางวัน
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() => setShift("B")}
                          className={`flex-1 py-3 rounded-r-xl border border-gray-300 border-l-0 items-center justify-center ${
                            shift === "B" ? "bg-[#1688fa] border-[#1688fa]" : "bg-gray-100"
                          }`}
                        >
                          <Text className={`font-kanit text-lg ${shift === "B" ? "text-white" : "text-gray-600"}`}>
                            กะกลางคืน
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>

                  {item?.type === "good" && (
                    <View className="w-full flex-row items-center justify-center rounded-xl">
                      <View className="flex-1 items-start justify-center rounded-xl py-2 m-2">
                        <Text className="text-lg text-gray-500 font-kanit">
                          {t("customer_reel")}
                        </Text>
                        <TextInput
                          onChangeText={(text) => setCustomer_reel(text)}
                          maxLength={40}
                          editable={item?.type === "good"}
                          value={customer_reel}
                          placeholder={t("customer_reel_placeholder")}
                          className="w-full bg-gray-100 text-gray-700 font-kanit rounded-xl px-4 py-4 mt-1 border border-gray-200"
                        />
                      </View>
                    </View>
                  )}
                </>
              ) : (
                <View className="w-full flex-1 items-center justify-center py-2 mt-4">
                  <TouchableOpacity
                    onPress={fetchWeight}
                    className="rounded-full bg-[#58d68d] px-6 shadow-md border-4 border-green-200"
                  >
                    <Text className="text-2xl text-white font-kanit pb-3 py-4 px-4">
                      {t("pull_weight_data")}
                    </Text>
                  </TouchableOpacity>
                </View>
              )}
            </View>

            {/* ปุ่มส่งข้อมูล / ยกเลิก */}
            <View className="w-full flex-row items-center justify-between py-2 pt-5 border-t border-gray-300">
              <View className="w-[48%] flex-row items-center justify-center">
                {/* ⚠️ ปลดเงื่อนไข error จากปุ่มยกเลิก ให้กดได้เสมอแม้ตาชั่งพัง (เว้นแต่กำลังโหลดข้อมูลอยู่) */}
                <TouchableOpacity
                  onPress={() => setModalVisible2(true)}
                  className={`w-full bg-[#ec7063] py-3 rounded-xl items-center shadow-md ${
                    loading ? "opacity-40" : ""
                  }`}
                  disabled={loading}
                >
                  <Text className="text-white text-lg font-kanit opacity-90">
                    {t("no_send_weight")}
                  </Text>
                </TouchableOpacity>
              </View>

              <View className="w-[48%] flex-row items-center justify-center">
                <TouchableOpacity
                  onPress={() => {
                    if (
                      item?.type === "good" &&
                      customer_reel.trim() === "" &&
                      !checkwarning &&
                      (item?.material_code?.startsWith("31") ||
                        item?.material_code?.startsWith("32"))
                    ) {
                      setModalReelcustomerVisible(true);
                    } else {
                      setModalVisible(true);
                    }
                  }}
                  className={`w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-md ${
                    !isShowscale || loading || error ? "opacity-40" : ""
                  }`}
                  disabled={!isShowscale || loading || (error as any)}
                >
                  <Text className="text-white text-lg font-kanit opacity-90">
                    {loading || error ? t("cannot_send") : t("send_weight")}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      </View>

      {/* Modal ยืนยันการส่งข้อมูล */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#F17736" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("question_send")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("question_send_data_weight")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                onPress={() => setModalVisible(false)}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {t("cancel")}
                </Text>
              </Pressable>
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalVisible(false);
                  postWeightData();
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal สำเร็จ */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessVisible}
        onRequestClose={() => setModalSuccessVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("success")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("send_data_weight_success")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => {
                  setModalSuccessVisible(false);
                  router.push({
                    pathname: weight == "0" ? "/screens/processwipsuccess" : "/screens/goodworksuccess",
                    params: {
                      item: JSON.stringify(item),
                      scale: JSON.stringify(scale),
                      item2: JSON.stringify(item2),
                    },
                  });
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* ⚠️ Modal ไม่สำเร็จ (มีปุ่มตรวจสอบสถานะล่าสุด) */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailedVisible}
        onRequestClose={() => setModalFailedVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("error")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {messagefailed ? messagefailed : "ขาดการเชื่อมต่อ ข้อมูลอาจกำลังบันทึกอยู่เบื้องหลัง กรุณาตรวจสอบสถานะ"}
            </Text>
            
            <View className="flex-col justify-between w-full">
              {/* ปุ่มเช็คสถานะ */}
              <Pressable
                className="w-full bg-[#1688fa] py-3 rounded-lg mb-3 shadow-sm"
                onPress={() => checkTransactionStatus()}
              >
                <Text className="text-center text-white font-kanit text-lg">
                  ตรวจสอบสถานะล่าสุด
                </Text>
              </Pressable>

              {/* ปุ่มปิด */}
              <Pressable
                className="w-full bg-gray-200 py-3 rounded-lg"
                onPress={() => setModalFailedVisible(false)}
              >
                <Text className="text-center text-gray-700 font-kanit text-lg">
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal กำลังโหลด */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={loadingresponse}
        onRequestClose={() => setLoadingresponse(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/80 px-4">
          <View className="flex items-center justify-center pb-3">
            <ActivityIndicator size="large" color="#F17736" />
            <Text className="text-center text-xl font-kanit text-white pl-2 pt-4">
              {t("loading_send_data_weight")}
            </Text>
            
            <Text className="text-center text-sm font-kanit text-red-400 mt-3 px-6">
              * ระบบกำลังประมวลผลข้อมูล {"\n"}
              กรุณาอย่าปิดหน้าจอหรือสลับแอป
            </Text>
          </View>
        </View>
      </Modal>

      {/* Modal ยืนยันการยกเลิก */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible2}
        onRequestClose={() => setModalVisible2(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#F17736" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("question_cancel")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("question_cancel_send_data_weight")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                onPress={() => setModalVisible2(false)}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {t("cancel")}
                </Text>
              </Pressable>
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalVisible2(false);
                  handleCancel();
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal ยกเลิกสำเร็จ */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessVisible2}
        onRequestClose={() => setModalSuccessVisible2(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("success")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("cancel_send_data_weight_success")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => {
                  setModalSuccessVisible2(false);
                  router.push({
                    pathname: "/screens/order_scales",
                    params: {
                      machine_code: item2?.machine_code,
                      item: JSON.stringify(item2),
                    },
                  });
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal ยกเลิกไม่สำเร็จ */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailedVisible2}
        onRequestClose={() => setModalFailedVisible2(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#ec7063" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("error")}
              </Text>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {messagefailed ? messagefailed : t("cancel_send_data_weight_failed")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => setModalFailedVisible2(false)}
              >
                <Text className="text-center text-white font-kanit">
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal แจ้งเตือนเรื่อง Reel Customer */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalReelcustomerVisible}
        onRequestClose={() => setModalReelcustomerVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            <View className="flex-col items-center justify-center pb-3">
              <View className="flex-row items-center justify-center">
                <Icon name="warning" size={24} color="#F1C40F" />
                <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                  {t("warning")}
                </Text>
              </View>
            </View>
            <Text className="text-center text-gray-600 font-kanit mb-1">
              {t("warning_no_customer_reel")}
            </Text>
            <Text className="text-center text-gray-600 font-kanit text-sm mb-6">
              {t("warning_check_customer_reel_before_send_weight")}
            </Text>
            <View className="flex-row justify-around">
              <Pressable
                className="flex-1 bg-[#58d68d] py-3 rounded-lg mx-1"
                onPress={() => {
                  setModalReelcustomerVisible(false);
                  setCheckwarning(true);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("ok")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
}